import api from "PFCore/api";
import { Id } from "PFCore/types";

export type AuditBoookingPlaceholderPayload = {
  ids: Id[];
  activityId: Id;
  profileId: Id;
  oldProfileId: Id;
  approverId: Id;
  requestReason: string;
};

export type CreateAuditBookingPlaceholderResponse = {
  bookingIds: Id[];
};

export const createAuditBookingPlaceholder = (
  data: AuditBoookingPlaceholderPayload
): Promise<CreateAuditBookingPlaceholderResponse> =>
  api({
    url: "booking_module/bookings/create_placeholder",
    method: "POST",
    data
  });
